import { useMemo } from 'react';
import { Check, X } from 'lucide-react';
import { LETTRE_HEX } from '../../utils/qcmTheme';

/**
 * Liste « qui a répondu quoi » — RÉSERVÉE au téléphone du prof (jamais
 * projetée). Répondants d'abord (pastille lettre A-D + ✓/✗ selon
 * est_correcte), puis les non-scannés grisés. Partagée entre la sheet du
 * compteur (pendant le scan) et le détail repliable du panneau résultats.
 */
const ListeReponsesEleves = ({ assignations, reponses }) => {
  const lignes = useMemo(() => {
    const parCode = new Map(reponses.map((r) => [r.code_aruco, r]));
    const repondants = [];
    const enAttente = [];
    for (const a of assignations) {
      const r = parCode.get(a.codeAruco);
      const nom = a.prenom || a.eleveNom;
      if (r) repondants.push({ codeAruco: a.codeAruco, nom, lettre: r.reponse, correcte: r.est_correcte });
      else enAttente.push({ codeAruco: a.codeAruco, nom });
    }
    return { repondants, enAttente };
  }, [assignations, reponses]);

  if (assignations.length === 0) {
    return <p className="text-sm text-center py-4" style={{ color: 'rgba(255,255,255,.5)' }}>Aucun élève assigné</p>;
  }

  return (
    <div className="grid grid-cols-2 gap-x-3 gap-y-1.5">
      {lignes.repondants.map((e) => (
        <div key={e.codeAruco} className="flex items-center gap-2 min-w-0 py-1">
          <span
            className="flex items-center justify-center w-6 h-6 rounded-md font-black text-[12px] text-white flex-none"
            style={{ background: LETTRE_HEX[e.lettre] || 'rgba(255,255,255,.2)', fontFamily: "'Archivo', 'Inter', system-ui, sans-serif" }}
          >
            {e.lettre}
          </span>
          <span className="text-[13px] font-semibold text-white truncate">{e.nom}</span>
          {e.correcte === true ? (
            <Check size={13} className="flex-none" style={{ color: '#7fe0b4' }} />
          ) : e.correcte === false ? (
            <X size={13} className="flex-none" style={{ color: '#f0938a' }} />
          ) : null}
        </div>
      ))}
      {lignes.enAttente.map((e) => (
        <div key={e.codeAruco} className="flex items-center gap-2 min-w-0 py-1" style={{ opacity: .45 }}>
          <span
            className="flex items-center justify-center w-6 h-6 rounded-md font-black text-[12px] text-white flex-none"
            style={{ background: 'rgba(255,255,255,.12)' }}
          >
            —
          </span>
          <span className="text-[13px] font-semibold text-white truncate">{e.nom}</span>
        </div>
      ))}
    </div>
  );
};

export default ListeReponsesEleves;
